import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import styles from './styles.module.scss';
import { setSendEmitApi, setCardInfo } from '@Redux/search/actions';
import { setAllSelected } from '@Redux/search/All/action';
import { setGroupSelected } from '@Redux/search/Group/action';
import { setHotelSelected } from '@Redux/search/Hotel/action';
import { setVocationSelected } from '@Redux/search/Vacation/action';
import { setTicketSelected } from '@Redux/search/Ticket/action';
import { setFlightSelected } from '@Redux/search/Flight/action';
import { RootState } from '@Redux/search/store';
import UseTempData from './subComponent/useHook/UseTempData';
import Group from './subComponent/Group';
import Hotel from './subComponent/Hotel';
import Ticket from './subComponent/Ticket';
import Vocation from './subComponent/Vacation';
import Flight from './subComponent/Flight';
import All from './subComponent/All';
import SlidePage from '@components/Common/SlidePage';
import SlideFooter from '@components/Common/SlideFooter';

interface I_FiltersProps {
    isSlideOpen: boolean; // 是否啟動M版側開
    setSlideOpen: (isOpen: boolean) => void; // 讓M版篩選按紐啟動側開用callback
    // onConfirm: (finalItems: I_FilterItem[]) => void; // M版按確認後
    filterData?: any; //個館別型別要想一下對應參數
    // filterData: I_SearchAllFilter;
}

const Filters: React.FC<I_FiltersProps> = ({ isSlideOpen, setSlideOpen }) => {
    const moduleName = 'filters';
    const dispatch = useDispatch();
    const { TagList, AllCardsInfo } = useSelector((state: RootState) => state.search.reducer);
    // const recordY = useRef(0);
    // const { GroupFilterSelected } = useSelector((state: RootState) => state.search.GroupReducer);
    // const { HotelFilterSelected } = useSelector((state: RootState) => state.search.HotelReducer);
    // const { TicketFilterSelected } = useSelector((state: RootState) => state.search.TicketReducer);
    // const { VocationFilterSelected } = useSelector(
    //     (state: RootState) => state.search.VocationReducer
    // );
    // const { AllFilterSelected } = useSelector((state: RootState) => state.search.AllReducer);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    // const [tempSelectData, setSelectTempData] = useState(); //M版回上一步則返回一開始的篩選值
    const [tempSelectData, selectedState, dispatchStore] = UseTempData([TagList, isSlideOpen]);
    const clearAllFilter = () => {
        switch (
            TagList // 清除篩選條件 不更新排序、產品類型(SortType)
        ) {
            case 'grp':
                return dispatch(
                    setGroupSelected({
                        // 用戶篩選的值
                        selectedPrices: [],
                        selectedDestinationID: [],
                        selectedDays: [],
                        selectedTravelType: [],
                        selectedDepartureID: [],
                        selectedAirlineID: [],
                        selectedTags: [],
                        selectedIsEnsureGroup: null,
                        Page: 1,
                        PageSize: 10,
                    })
                );
            case 'vac':
                return dispatch(
                    setVocationSelected({
                        selectedPrices: [],
                        selectedDestinationID: [],
                        selectedTrafficTypes: [],
                        selectedProductGroups: [],
                        selectedItineraries: [],
                        selectedHotelLevels: [],
                        selectedCityZones: [],
                        Page: 1,
                        PageSize: 10,
                    })
                );
            case 'htl':
                return dispatch(
                    setHotelSelected({
                        selectedPrices: [],
                        selectedDestinationID: [],
                        selectedRoomStatus: [],
                        selectedRatings: [],
                        selectedSubjects: [],
                        selectedFacilities: [],
                        selectedHotelLevels: [],
                        selectedHotelSubjects: [],
                        Page: 1,
                        PageSize: 10,
                    })
                );
            case 'etk':
                return dispatch(
                    setTicketSelected({
                        selectedPrices: [],
                        selectedDestinationID: [],
                        selectedProductTypeID: [],
                        Page: 1,
                        PageSize: 10,
                    })
                );
            case 'flt':
                return dispatch(
                    setFlightSelected({
                        selectedPrices: [],
                        selectedDestinationID: [],
                        selectedDepartureID: [],
                        selectedDepartureMonth: [],
                        Page: 1,
                        PageSize: 10,
                    })
                );
            default:
                return dispatch(
                    setAllSelected({
                        selectedPrices: [],
                        selectedDestinationID: [],
                        selectedProductType: ['grp', 'vac', 'htl', 'etk', 'flt'],
                        Page: 1,
                        PageSize: 10,
                    })
                );
        }
    };

    const ProductFilter = React.useMemo(() => {
        // const { TagList } = useSelector((state: RootState) => state.search.reducer);
        console.log('filters index');
        switch (TagList) {
            case 'grp':
                return <Group />;
            case 'vac':
                return <Vocation />;
            case 'htl':
                return <Hotel />;
            case 'etk':
                return <Ticket />;
            case 'flt':
                return <Flight />; 
            default:
                return <All />;
        }
    }, [TagList]);

    // useEffect(() => {
    //     //TagList 切換都直接打api，不等M版篩選的確定按鈕才送出、清除所有上限
    //     let [params, apiUrl] = tagListSwitch();
    //     dispatch(setFilterDataLoading(true));
    //     dispatch(setCityLength({}));
    //     dispatch(getData({ apiUrl, params }));
    // }, [TagList]);

    // const tagListSwitch = useCallback(() => {
    //     let params = '';
    //     let apiUrl = 'searchall';
    //     try {
    //         switch (TagList) {
    //             case 'grp':
    //                 params = selectUrl(GroupFilterSelected, CityLength);
    //                 apiUrl = 'searchtravel';
    //                 break;
    //             case 'htl':
    //                 params = selectUrl(HotelFilterSelected, CityLength);
    //                 apiUrl = 'searchhotel';
    //                 break;
    //             case 'vac':
    //                 params = selectUrl(VocationFilterSelected, CityLength);
    //                 apiUrl = 'searchvacation';
    //                 break;
    //             case 'etk':
    //                 params = selectUrl(TicketFilterSelected, CityLength);
    //                 apiUrl = 'searchactivity';
    //                 break;
    //             default:
    //                 params = selectUrl(AllFilterSelected, CityLength);
    //                 apiUrl = 'searchall';
    //         }
    //     } catch (e) {
    //         alert(e); //如果參數組成有誤或城市超過上限 錯誤提示 帶ux確定再決定錯誤處理是否放在這
    //     }
    //     const KEYWORD = window.sessionStorage.getItem('Keyword') || '';
    //     params += 'Keyword=' + KEYWORD;
    //     return [params, apiUrl];
    // }, [TagList]);

    return (
        <aside className={cN(moduleName, styles[`${moduleName}`])}>
            {isMobile ? (
                <div className={styles[`${moduleName}_M`]}>
                    <SlidePage
                        title="篩選"
                        visible={isSlideOpen}
                        setIsVisible={() => {
                            setSlideOpen(false);
                            dispatch(dispatchStore(tempSelectData));
                            dispatch(setCardInfo(AllCardsInfo));
                        }}
                    >
                        <div className={cN(styles.SlideContent, styles.border_rs_20)}>
                            {ProductFilter}
                        </div>
                        <SlideFooter
                            onClickLeftBtn={clearAllFilter}
                            onClickRightBtn={() => {
                                setSlideOpen(false);
                                dispatch(setSendEmitApi(true));
                                dispatch(dispatchStore(selectedState));
                            }}
                            leftBtnText="重設條件"
                            rightBtnText="確定"
                        />
                    </SlidePage>
                </div>
            ) : null}
            {!isMobile && (
                <>
                    <div className={styles[`${moduleName}_info`]}>
                        <span>進階篩選</span>
                        <span className={styles[`${moduleName}_clear`]} onClick={clearAllFilter}>
                            清除條件
                        </span>
                    </div>
                    {ProductFilter}
                </>
            )}
        </aside>
    );
};

export default Filters;
